import { StringTemplate } from './stringTemplate';

export class TemplateUtil {
	static getStringTemplateEngine(Templates: any): KnockoutTemplateEngine {
		var templateEngine: KnockoutTemplateEngine = <KnockoutTemplateEngine>(
			new ko.nativeTemplateEngine()
		);

		templateEngine.makeTemplateSource = (template: any, templateDocument?: Document): any => {
			if (typeof template == 'string') {
				return new StringTemplate(template, Templates, templateDocument);
			} else if (template.nodeType == 1 || template.nodeType == 8) {
				// Anonymous template
				return new ko.templateSources.anonymousTemplate(template);
			} else throw new Error('Unknown template type: ' + template);
		};

		return templateEngine;
	}
}
